import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

function formatNumber(value, hasDecimals, decimalPlaces, hasCommas) {
  let formatted;

  if (hasDecimals) {
    formatted = value.toFixed(decimalPlaces);
  } else {
    formatted = Math.floor(value).toString();
  }

  if (hasCommas) {
    const parts = formatted.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    formatted = parts.join('.');
  }

  return formatted;
}

function animateNumbers() {
  const numbers = document.querySelectorAll('.homepage .statistics-panel__number');

  if (!numbers.length) return;

  numbers.forEach((element) => {
    const text = element.textContent.trim();
    const match = text.match(/^([^\d]*)([\d,]+\.?\d*)(.*)/);

    if (!match) return;

    const prefix = match[1];
    const numberStr = match[2];
    const suffix = match[3];
    const hasCommas = numberStr.includes(',');
    const hasDecimals = numberStr.includes('.');
    const decimalPlaces = hasDecimals ? numberStr.split('.')[1].length : 0;
    const targetNumber = parseFloat(numberStr.replace(/,/g, ''));
    const counter = { value: 0 };

    gsap.to(counter, {
      value: targetNumber,
      duration: 2,
      ease: 'power2.out',
      snap: hasDecimals ? false : { value: 1 },
      scrollTrigger: {
        trigger: element,
        start: 'top 90%',
        once: true,
      },
      onUpdate() {
        element.textContent = prefix + formatNumber(counter.value, hasDecimals, decimalPlaces, hasCommas) + suffix;
      },
    });
  });
}

window.addEventListener('DOMContentLoaded', animateNumbers);
